import ActionSheet from 'src/components/ActionSheet';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/store';
import Button from 'src/components/Order/Button';
import Pagination from 'src/components/Order/Pagination';
import { draftSetFillOptions } from 'src/reducer/order/orderReducer';
import { types as rs } from 'earn-ts';
import { useTranslation } from 'react-i18next';
import { pickName } from 'src/utils';
import { OptionGroupsEditor } from 'src/components/Order/OptionGroupsEditor';
import classNames from 'classnames';

interface PopupGroupOptionProps {
  openActionSheet: boolean;
  setOpenActionSheet: (value: boolean) => void;
}

export default function PopupGroupOption({
  setOpenActionSheet,
  openActionSheet,
}: PopupGroupOptionProps) {
  const dispatch = useAppDispatch();

  const { foods, draftSet, optionGroup } = useAppSelector(state => state.order);
  const optionsPage = useAppSelector(state => state.order.optionsPage);

  const { language } = useTranslation(['main']).i18n;
  const foodDef = optionsPage ? foods[optionsPage.foodId] : null;

  const [messageError, setMessageError] = useState('');

  const [localState, setLocalState] = useState<rs.OrderItem[]>([]);

  const [page, setPage] = useState(0);

  useEffect(() => {
    if (openActionSheet) {
      const data =
        optionsPage == null || draftSet == null
          ? []
          : draftSet.sections[optionsPage.sectionId].filter(
              it => it.food_id == optionsPage.foodId,
            );
      setLocalState(data);
      setPage(data.length - 1);
    } else {
      setMessageError('');
    }
  }, [openActionSheet]);

  // console.log('GroupOption page render ', localState, ' page=', page, { draftSet, optionsPage });

  const checkLessThanMinimumQuantity = () => {
    const optionsSelected = localState[page]?.options;
    const options = foodDef?.['option_groups'] ?? [];
    for (const option of options) {
      const minQuatity = optionGroup?.[option]?.min;
      const quantity = optionsSelected?.[option]?.flags?.length ?? 0;
      if (minQuatity && quantity < minQuatity)
        return `You must select at least ${minQuatity} option in group ${option}`;
    }
    return false;
  };
  const minQuatity = checkLessThanMinimumQuantity();

  const handleConfirm = () => {
    if (!minQuatity) {
      dispatch(draftSetFillOptions(localState));
      setOpenActionSheet(false);
      setMessageError('');
    } else {
      setMessageError(minQuatity);
    }
  };

  return (
    <div>
      <ActionSheet
        open={openActionSheet}
        setOpen={setOpenActionSheet}
        title="Options">
        {!openActionSheet ||
        draftSet == null ||
        optionsPage == null ||
        localState.length <= page ? (
          <div>Loading...</div>
        ) : (
          <div className="bg-shadow-1 h-full w-full flex flex-col">
            <div className="p-3 grow overflow-auto pb-48">
              <OptionGroupsEditor
                foodDef={foodDef!}
                selectedFoodId={optionsPage.foodId}
                page={page}
                state={localState}
                onChange={value => {
                  setMessageError('');
                  setLocalState(value);
                }}
              />
              <div className="text-[14px] text-left mt-4 text-red-500">
                {messageError}
              </div>
            </div>

            <div className="font-medium border-t-[1.5px] border-solid border-shadow-2 bg-white pt-5 pb-5 fixed bottom-0 left-0 w-full px-[5%]">
              {localState.length > 1 && (
                <Pagination
                  totalPage={localState.length}
                  activePage={page}
                  onChangePage={value => {
                    setMessageError('');
                    setPage(value);
                  }}
                />
              )}
              <Button
                className={classNames('sticky w-full py-2 text-[16px]', {
                  'bg-primary': !minQuatity,
                  'bg-shadow-1 !text-shadow-4': minQuatity,
                })}
                onClick={handleConfirm}
                label="Confirm"
              />
            </div>
          </div>
        )}
      </ActionSheet>
    </div>
  );
}
